import { Box, Tab, Tabs } from '@mui/material';
import i18next from 'i18next';
import React from 'react';

/**
 * Memoized so this subtree only re-renders when the selected tab changes.
 * MUI Tabs re-measures its indicator with getBoundingClientRect on every commit,
 * forcing a synchronous layout of the whole page — with the datagrids below, each
 * re-render of the Tabs costs a full reflow (COR-1576).
 */
const SalesPlanningTabsComponent = ({ value, onChange }) => (
  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
    <Tabs aria-label="production planning tabs" value={value} onChange={onChange}>
      <Tab label={i18next.t('GENERAL.PRODUCT_PLURAL')} />
      <Tab label={i18next.t('GENERAL.RECIPE_PLURAL')} />
      <Tab label={i18next.t('GENERAL.INGREDIENT_PLURAL')} />
    </Tabs>
  </Box>
);

export const SalesPlanningTabs = React.memo(SalesPlanningTabsComponent);
